module.exports = __webpack_public_path__ + "static/media/icon-shield-person.e98affe8.svg";